__turbopack_context__.v({
  "paddingWrapper": "NumbersSection-module-scss-module__qhEnqW__paddingWrapper",
});
